import AhoyEvent from 'shared/ahoy_event';
import SocketAPI from 'vidio-chat';
import { buildChannel } from 'shared/utilities/channel_builder';
import Page from 'shared/components/page';
import $ from 'jquery';

export default class PinMessage {
  constructor() {
    this.ui = {
      pinnedMessageDisplay: '.livestreaming-discussion__pinned-message-display',
      pinnedMessageDisplayTimestamp: '.livestreaming-discussion__pinned-message-display__timestamp',
      pinnedMessageDisplayUsername: '.livestreaming-discussion__pinned-message-display__username',
      pinnedMessageDisplayContent: '.livestreaming-discussion__pinned-message-display__content',
      pinnedMessageDetailContainer: '.livestreaming-discussion__pinned-message-detail-container',
      pinnedMessageDetailOverlay: '.livestreaming-discussion__pinned-message-detail-overlay',
      pinnedMessageDetailIgnoreButton: '.livestreaming-discussion__pinned-message-detail-ignore-button',
      pinnedMessageDetailFull: '.livestreaming-discussion__pinned-message-detail-full',
      pinnedMessageDetailPreview: '.livestreaming-discussion__pinned-message-detail-preview',
      pinnedMessageDetailCloseButton: '.livestreaming-discussion__pinned-message-detail-close-button',
      pinnedMessageDetailTimestamp: '.livestreaming-discussion__pinned-message-detail__timestamp',
      pinnedMessageDetailUsername: '.livestreaming-discussion__pinned-message-detail__username',
    };

    this.pinnedMessageDate = null;
    this.urlRegex = new RegExp("(https?://)?([a-z0-9_]+:[a-z0-9_]+@)?([a-z0-9.-]+\\.[a-z]{2,4})(:[0-9]+)?(/.*)?", "i");
  }

  init() {
    this.bindPinnedMessageDisplay();
    SocketAPI.runWhenConnectionOpen(this.requestPinMessage.bind(this));
  }

  bindPinnedMessageDisplay() {
    $(this.ui.pinnedMessageDisplay).click(this.showPinnedMessageDetail.bind(this));
    $(this.ui.pinnedMessageDetailCloseButton).click(this.hidePinnedMessageOverlay.bind(this));
    $(this.ui.pinnedMessageDetailIgnoreButton).click(this.ignorePinnedMessageDisplay.bind(this));
    $(this.ui.pinnedMessageDetailContainer).click(this.sendDetailContainerEvent.bind(this));
  }

  requestPinMessage() {
    SocketAPI.subscribe(buildChannel('live', 'pin', Page.id()))
  }

  sendDetailContainerEvent(e) {
    if (e.target.href != undefined) {
      this.sendAhoyPinnedMessageEvent('click', e.target.href);
      window.open(e.target.href, '_blank');
      return false;
    }
  }

  showPinnedMessageOverlay() {
    let element = document.querySelector(this.ui.pinnedMessageDetailOverlay);
    if (!element) {
      return;
    }
    this.sendAhoyPinnedMessageEvent('open');
    element.classList.remove('hide-me');
  }

  hidePinnedMessageOverlay() {
    let element = document.querySelector(this.ui.pinnedMessageDetailOverlay);
    if (!element) {
      return;
    }
    this.sendAhoyPinnedMessageEvent('close');
    element.classList.add('hide-me');
  }

  togglePinnedMessageDetailOverlay() {
    $(this.ui.pinnedMessageDetailOverlay).toggleClass('hide-me');
  }

  ignorePinnedMessageDisplay() {
    this.sendAhoyEvent('ignore', 'pinned-message');
    this.togglePinnedMessageDetailOverlay();
    this.hidePinnedMessageDisplay();
  }

  showPinnedMessageDetail(e) {
    if(e.target.href !== undefined) {
      this.sendAhoyPinnedMessageEvent('click', e.target.href);
      window.open(e.target.href, '_blank');
      return false;
    }

    this.showPinnedMessageOverlay();
  }

  linkifyMessage(originalMessage) {
    var safeEnter = originalMessage.replace(new RegExp("\n", "g"), " \n ");
    var splittedOriginalMessage = safeEnter.split(" ");
    var linkifiedMessage = "";
    var url = [];

    for(var i = 0; i < splittedOriginalMessage.length; i ++) {
      var content = splittedOriginalMessage[i];
      if(this.urlRegex.test(content)) {
        if(content.includes("http")) {
          url.push(content);
          linkifiedMessage += '<a href='+content+' target="_blank">'+ content +'</a>';
        } else {
          url.push("//" + content);
          linkifiedMessage += '<a href=//'+content+' target="_blank">'+ content +'</a>';
        }
      } else {
        linkifiedMessage += content;
      }
      linkifiedMessage += " ";
    }

    return { message: linkifiedMessage, urls: url };
  }

  renderPinnedMessage(message) {
    var date = new Date(message.created_at);
    if(this.pinnedMessageDate === null || date > this.pinnedMessageDate) {
      this.pinnedMessageDate = date;
      var messageHours = date.getHours();
      var messageMinutes = date.getMinutes();

      messageHours = messageHours > 9 ? messageHours : ("0" + messageHours);
      messageMinutes = messageMinutes > 9 ? messageMinutes : ("0" + messageMinutes);

      var displayDate = messageHours + ":" + messageMinutes;
      var displayUsername = message.user.name;

      $(this.ui.pinnedMessageDisplay).removeClass('hide-me');
      $(this.ui.pinnedMessageDisplayTimestamp).text(displayDate);
      $(this.ui.pinnedMessageDisplayUsername).text(displayUsername);

      var originalMessage = message.content;
      var result = this.linkifyMessage(originalMessage);

      $(this.ui.pinnedMessageDisplayContent).html(result.message)
      this.renderPinnedMessageDetail(displayDate, displayUsername, result);
      this.sendAhoyPinnedMessageEvent('impression');
    }
  }

  renderPinnedMessageDetail(displayDate, displayUsername, result) {
    $(this.ui.pinnedMessageDetailPreview).addClass('hide-me');

    var pinnedMessageDetailFull = $(this.ui.pinnedMessageDetailFull);
    $(this.ui.pinnedMessageDetailTimestamp).text(displayDate);
    $(this.ui.pinnedMessageDetailUsername).text(displayUsername);

    pinnedMessageDetailFull.html(result.message);
  }

  hidePinnedMessageDisplay() {
    $(this.ui.pinnedMessageDisplay).addClass('hide-me');
  }
  
  params(data) {
    return $.extend({ commentable_id: Page.id(), commentable_type: Page.type() }, data);
  }

  sendAhoyPinnedMessageEvent(action, content) {
    if (content == undefined) {
      let contentEl = document.querySelector('.livestreaming-discussion__pinned-message-detail-full');
      if (contentEl) {
        content = contentEl.innerHTML;
      }
    }
    AhoyEvent.send('VIDIO::CHAT', {
      action: action,
      feature: 'pinned message',
      livestreaming_id: this.params().commentable_id,
      section: 'chat',
      content: content
    });
  }

  sendAhoyEvent(action, feature) {
    AhoyEvent.send('VIDIO::CHAT', {
      action: action,
      feature: feature,
      livestreaming_id: this.params().commentable_id
    });
  }
}
